import React from 'react';
import * as Yup from 'yup';

export const ContentPeerUserUnsubscribeValidatorSchema = Yup.object().shape({
    activeTo: Yup.date()
        .typeError("invalidDate")
        .required('required'),
});
